import React from "react"
import { Box } from "@mui/material"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"
import { autoEuropeDrawerData, autoEuropeDrawerErrors, clearAutoEuropeSignals } from "Pages/AutoEuropeTool/Page/@signals"

export default function AutoEuropeDrawerFooter({ onSubmit, isLoading }) {
	return <Box>
		<ButtonLoadingSeeker
			sx={{ m: 1 }}
			startIcon={<IconSeeker icon="circle-left" tooltip="Cancel"/>}
			onClick={clearAutoEuropeSignals}
			variant="outlined"
		>
			Cancel
		</ButtonLoadingSeeker>
		<ButtonLoadingSeeker
			sx={{ m: 1 }}
			loading={isLoading}
			startIcon={<IconSeeker icon="floppy-disk" tooltip="Save"/>}
			disabled={!Object.values(autoEuropeDrawerErrors.value).every(a => a)}
			onClick={() => onSubmit(autoEuropeDrawerData.value)}
		>
			Save
		</ButtonLoadingSeeker>
	</Box>
}
